/**
 * Where this app talks and where it remembers.
 *
 * `VITE_API_URL` is empty in dev, so the base url is the same-origin `/api/v1`
 * that Vite proxies to the API container. Set it to an absolute origin (which
 * must be listed in `CORS_ORIGINS`) to point a built bundle at a deployment.
 */
const origin = (import.meta.env.VITE_API_URL ?? '').replace(/\/+$/, '');

export const API_BASE_URL = `${origin}/api/v1`;

/**
 * This app's IndexedDB. Each app has its own device identity (D-06: one
 * active device per employee, and a supervisor's laptop is not a worker's
 * phone), so the two names must never be shared.
 */
export const IDB_NAME = 'saniplus-admin';

/**
 * The landing route.
 *
 * `/dashboard` for everybody who can read it. A caller whose permissions hide
 * the dashboard lands on the first nav item they *can* see — `landingPath()` in
 * `components/nav.ts` computes it, and `RequireAuth`'s post-login bounce uses
 * that rather than this constant.
 */
export const HOME_PATH = '/dashboard';

/**
 * Shown on the login screen's footer and in the account menu's support line.
 *
 * A0-login/JUDGEMENT.md G-3: "the footer survives every breakpoint and it is
 * where a supervisor on the phone with support will be asked to look."
 */
export const APP_VERSION: string = import.meta.env.VITE_APP_VERSION ?? '1.0.0-dev';

/**
 * Where the employee app lives, for the one screen that hands a person over
 * to it (`components/NoPortalAccess.tsx`, Phase 4 Q6). Optional: unset in dev
 * — the worker PWA is another Vite server on another port, and no local
 * address is worth printing on a screen a real worker may read — and set by a
 * deployment (`VITE_WORKER_APP_URL=https://…`). When it is unset the screen
 * names the app without a link; it never invents an address.
 */
const workerAppUrl = (import.meta.env.VITE_WORKER_APP_URL ?? '').trim();
export const WORKER_APP_URL: string | null = workerAppUrl === '' ? null : workerAppUrl;
